export default "__VITE_ASSET__BCW_wXQZ__"